import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory, RouteComponentProps } from 'react-router-dom';
import * as api from "../../api";
import { useDispatch, useSelector } from 'react-redux';
import { Container } from "@material-ui/core";
import { saveDMCQuestions, saveDMCAnswers, RemoveAllDMCData } from '../../ducks/redux/actions/FinancialReferral';
import { useTranslation } from 'react-i18next';
import ExitModalAndSave from '../Modal/ExitModalAndSave';
import Button from "../../Button/Button";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import "./index.css";
import { detectMobile } from '../../utils/formatting';
import { userChosenVandalismQuestion, userChosenVulnerabilityQuestion, repairPriorityValue, userChosenDmcLocation, saveDMCRiskRating } from '../../ducks/redux/actions/userChoices';
import Message from '../../storybook/Message';
import HeaderJourney from '../../storybook/Header/HeaderJourney';
import BackModal from '../Modal/BackModal';
import '../Customer360View/index.scss'
import { workOrderRepairObject } from '../../ducks/redux/actions/getAddress';
import Loader from 'react-loader-spinner';
import { FeatureFlags } from '../contexts/FeatureFlags';
import { CasePriority, RepairPriorityCode, RepairPriorityPayload } from '../../models/Repair/RepairPriority';
import { RepairChannel } from '../../models/Repair/RepairChannel';
import moment from 'moment';

interface DMCProps extends RouteComponentProps<any> { }

const DMCQuestions: React.FC<DMCProps> = (props: any) => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = detectMobile();
  const [isLoading, setIsLoading] = useState(false);
  const [dmcQuestions, setDmcQuestions] = useState<any>();
  const { featureMedia }: any = useContext(FeatureFlags);
  const [error, setError] = useState("");
  const history = useHistory();
  const workOrderObject = useSelector((state: any) => state.addresses?.workOrderRepair);
  const dmcAnswersFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCAnsData);
  const assetByIdDataObject = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  let priorityCodeValue = useSelector((state: any) => state.dashboardReducer.formState?.priorityCode);
  let [currentQuestion, setCurrentQuestion] = useState(parseInt(id) || 1);
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const selectedSorCodeValue = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const selectedproperty = useSelector((state: any) => state?.userChoicesReducer?.userChosenPropertyType);
  const dmcInspectionSorCodes = useSelector((state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues);
  const [userAnswers, setUserAnswers] = useState<{ [key: string]: any }>({});
  const dmcRepairSorCodeValues = useSelector(
    (state: any) => state?.userChoicesReducer?.dmcRepairSorCodeValues
  );
  const selectedRepairReasonObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );
   const isHHSRSRepairEnabledToggleValue = useSelector(
      (state: any) =>  state?.userChoicesReducer?.checkHHRSRepairEnabledToggleValue
    );
const savedHazardQuestions = useSelector((state: any) => state.hazard?.hazardQuestions);
  const TenureCodeValue = useSelector((state: any) => state?.userChoicesReducer?.TenureCode);
  const [isAnaTypeValue, setIsAnaTypeValue] = useState(false);
  const fetchDMCQuestionsData = async () => {
    try {
      const responseData = await api.getQuestionnaireMasterData()
      const keyValuePairs = responseData[0]?.namespace?.keyValues;
      for (const data of Object.entries(keyValuePairs)) {
        const [key, value] = data;
        if (value && (value as any).id === '47') {
          setDmcQuestions(value)
          dispatch(saveDMCQuestions(value));
          setIsLoading(false)
        }
      }

    } catch (e) {
      console.log("Error occured!")
      setIsLoading(false)
    }
  }
  useEffect(() => {
    if (dmcAnswersFromReducer) {
      setUserAnswers(dmcAnswersFromReducer);
    }
  }, [dmcAnswersFromReducer]);

  useEffect(() => {
    if (customerDetails?.preferences?.length > 0) {
      setIsAnaTypeValue(customerDetails?.preferences?.some((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds'))
    }
    setIsLoading(true)
    fetchDMCQuestionsData()
  }, [])

  const navigateTo = (path: string) => {
    props.history.push(path);
  };

  const roomCodeMapping: { [key: string]: string } = {
    '1': 'Bathroom',
    '2': 'Bedroom',
    '3': 'Kitchen',
    '4': 'Multiple Rooms',
    '5': 'Other room in your home',
  };

  const UpdateWorkOrder = (field: boolean) => {
    try {
      setIsLoading(true);
      workOrderObject.priority = priorityCodeValue; // set priority code value to work order object
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      saveAssessmentInformation();
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      )
    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
      setIsLoading(false);
    }
  };

  const saveAssessmentInformation = () => {
    const assessmentInformation = {
      type: "DampAndMould",
      communicationPreference: workOrderObject?.assessmentInformation?.communicationPreference ?? undefined,
      outcome: workOrderObject?.assessmentInformation?.outcome ?? undefined,
      supplementaryQuestionResponses: Object.entries(userAnswers).map(([questionId, answer]) => {
        const question = dmcQuestions?.additionalInfo.find((q: any) => q.questionId === questionId);
        if (question?.label === "Which room(s) are affected?") {
          const formattedAnswer = Array.isArray(answer)
            ? answer.map((code: string) => roomCodeMapping[code] || code).join(', ') // Map codes to room names
            : roomCodeMapping[answer] || answer; // Handle single answer
          dispatch(userChosenDmcLocation(formattedAnswer));
        }
        return {
          questionId: questionId,
          questionLabel: question?.label || "",
          responseId: Array.isArray(answer) ? answer : [answer],
        };
      }),
      hasAdditionalNeeds: isAnaTypeValue,
      IsSupportedResident: TenureCodeValue.includes(customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode)
    }
    workOrderObject.assessmentInformation = assessmentInformation;
  }

  const handleContinue = async () => {
    const lastPageGroupId = dmcQuestions?.additionalInfo
      ?.map((question: any) => parseInt(question.pageGroupId))
      ?.reduce((max: number, current: number) => Math.max(max, current), 0);
    const unansweredQuestions = dmcQuestions?.additionalInfo
      ?.filter((question: any) => question.pageGroupId === currentQuestion.toString())
      ?.some((question: any) => {
        const answer = userAnswers[question.questionId];
        if (question.type === "List") {
          return !answer || answer === "" || answer === "Select";
        }
        if (question.type === "Multiple") {
          return !answer || answer.length === 0;
        }
        return !answer;
      });

    if (unansweredQuestions) {
      setError("Please answer all the questions to continue.")
    } else if (currentQuestion < lastPageGroupId && !unansweredQuestions) {
      setError("");
      setCurrentQuestion(currentQuestion + 1)
      dispatch(saveDMCAnswers(userAnswers));
      // Call wo patch and bind all selected labels and answers
      UpdateWorkOrder(false);
      history.push(`/DampAndMouldAssesment/${currentQuestion + 1}`);
    } else {
      saveAssessmentInformation();
      const dmcAssessmentPriorityValue = await api.assessmentScoreDetermination(workOrderObject?.assessmentInformation);
      dispatch(saveDMCRiskRating(dmcAssessmentPriorityValue?.adjustedRiskRating));
      if (dmcInspectionSorCodes?.includes(userChosenSOR)) {
        if (dmcAssessmentPriorityValue?.adjustedRiskRating !== CasePriority.High) {
          workOrderObject.isEmergency = false;
        }
        // Adding isANATypes for customer preferences
        let repairPriorityPayload: RepairPriorityPayload = {
          isEmergency: workOrderObject?.isEmergency,
          repairType: userChosenSOR,
          description: workOrderObject?.description,
          channel: RepairChannel.CustomerSelfService,
          raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
          riskRating: dmcAssessmentPriorityValue?.adjustedRiskRating,
          assessmentType: workOrderObject?.assessmentInformation?.type,
          tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode,
          workProgramme: workOrderObject?.workProgramme || 'RESP',
          premisesType: workOrderObject?.premisesType || assetByIdDataObject?.assetType,
          isAnaType: isAnaTypeValue,
          isV14Upgradable: selectedRepairReasonObject?.[0]?.isV14Upgradable || false,
          hasSeasonalPriority: selectedRepairReasonObject?.[0]?.hasSeasonalPriority || false
        }
        const dmcRepairPriority =
          (await api.postRepairPriority(repairPriorityPayload))?.repairPriority;
        if (dmcRepairPriority === RepairPriorityCode.DampAndMouldEmergency) {
          workOrderObject.isEmergency = true;
        }
        priorityCodeValue = dmcRepairPriority;
        dispatch(repairPriorityValue(priorityCodeValue));
      }
      if (workOrderObject?.isEmergency !== true) {
        const isVulnerable = Object.keys(userAnswers).includes("q7_1") && userAnswers["q7_1"]?.some((a: string) => ['2', '3', '4', '5'].includes(a));
        if (isVulnerable) {
          dispatch(userChosenVulnerabilityQuestion("Yes"));
        }
        else {
          dispatch(userChosenVulnerabilityQuestion("No"));
        }
      }
      const outcomes = {
        riskRating: dmcAssessmentPriorityValue?.riskRating,
        totalScore: dmcAssessmentPriorityValue?.totalScore,
        vulnerabilityScore: dmcAssessmentPriorityValue?.vulnerabilityScore,
        adjustedRiskRating: dmcAssessmentPriorityValue?.adjustedRiskRating,
        vulnerabilityRiskRating: dmcAssessmentPriorityValue?.vulnerabilityRiskRating
      };
      workOrderObject.assessmentInformation.outcome = outcomes;
      dispatch(workOrderRepairObject(workOrderObject));
      UpdateWorkOrder(false);
      dispatch(saveDMCAnswers(userAnswers));
      if (featureMedia === "true") {
        navigateTo("/uploadmedia");
      } else if (assetByIdDataObject?.statuses.isInDefects && vandalismConfigValue) {
        navigateTo("/VandalismQuestion");
      } else if (savedHazardQuestions?.length === 0 || isHHSRSRepairEnabledToggleValue === false) {
        dispatch(userChosenVandalismQuestion(""));
        navigateTo("/VulnerabilityQuestion");
      }
      else{
        navigateTo("/customerdetails");
      }
    }
  };

  const backButtonHandler = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1)
      history.push(`/DampAndMouldAssesment/${currentQuestion - 1}`);
      window.location.reload();
    } else if (selectedproperty === "Property" && (dmcRepairSorCodeValues.includes(selectedSorCodeValue) || dmcInspectionSorCodes.includes(selectedSorCodeValue))) {
      props.history.push("/RepairAdditionalDetails");
    } else {
      props.history.push("/ConfirmedDampMould");
    }

  };

  const saveDraftAndExit = () => {
    UpdateWorkOrder(true);
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderRepairObject(worksOrder))
    props.history.push("/customer360View");
  }

  const exitButtonHandler = () => {
    dispatch(RemoveAllDMCData(null));
    props.history.push("/customer360View");
  }

  const dropDownHandler = (questionId: string, e: any) => {
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: e.target.value,
    }));
    setError("");
  }

  const handleCheckBox = (questionId: string, e: any) => {
    const selectedAnswers = userAnswers[questionId] || [];
    if (e.target.checked) {
      selectedAnswers.push(e.target.value);
    } else {
      const index = selectedAnswers.indexOf(e.target.value);
      if (index > -1) {
        selectedAnswers.splice(index, 1);
      }
    }
    setUserAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionId]: selectedAnswers,
    }));
    setError("");
  }

  const bindDMCQuestions = (id: number) => {
    return dmcQuestions?.additionalInfo
      ?.filter((question: any) => question.pageGroupId === (id).toString())
      ?.map((question: any) => (
        <div key={question.id}>
          <h3 className="pt-20 pb-12">{question.label}</h3>
          <div className="mt-2">
            {question.type === 'List' ? (
              <select aria-label={question.questionId} key={question.questionId}
                onChange={(e) => dropDownHandler(question.questionId, e)}
                value={userAnswers[question.questionId] || ""} className='input-text-select height-44'>
                <option>Select</option>
                {question.options.map((option: any) => (

                  <option key={option.value} value={option.id}>
                    {option.value}
                  </option>
                ))}
              </select>
            ) : question.type === 'Multiple' ? (
              <div className={`grid ${(question.options.length > 4 && !isMobile) ? 'md:grid-cols-2' : 'grid-cols-1'}`}>
                {question.options.map((option: any) => (
                  <div key={option.value} className={`mb-1 ${isMobile ? 'flex w-full' : 'flex'}`}>
                    <fieldset>
                      <legend className="sr-only">{question.label}

                      </legend>
                      <input
                        type="checkbox"
                        id={`${question.questionId}-${option.id}`}
                        name={question.questionId}
                        className="checkPos"
                        value={option.id}
                        aria-label={option.value}
                        checked={userAnswers[question.questionId]?.includes(option.id) || false}
                        onChange={(e) => handleCheckBox(question.questionId, e)}
                      />
                    </fieldset>
                    <label
                      htmlFor={`${question.questionId}-${option.id}`}
                      className={`ml-8 ${isMobile ? 'inline-block w-90' : ''}`}
                    >
                      {option.value}
                    </label>
                  </div>

                ))}
                <div className='mt-4'></div>
              </div>
            ) : null}
          </div>
        </div>
      ));
  }

  return (<>
    <HeaderJourney></HeaderJourney>
    <Container id="supp-main-container" className="parent-footer" role="main">
      {isLoading && (
        <div className="pl-2">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={50}
            width={50}
          />
        </div>
      )
      }
      <div className="padding-repair">
        <div role="alert" className="alert mb-8 p-0">
          <Message className="info-msg">
            {t("DMC_Notification_Message")}
          </Message>
        </div>
      </div>

      <div className="relative pb-2 padding-repair">
        {bindDMCQuestions(currentQuestion)}
        {(error !== "") && <Message className="error-msg">{t(error)}</Message>}
      </div>

      <div className="col-md-12 marginTop-auto">
        <div className="row m-0 footer-actionbtn">
          <div className="col btn-top padding-repair mb-0">
            <BackModal id="duprepair-backmodal" back={backButtonHandler} />
            <ExitModalAndSave
              id="custDetails-exitmodal"
              exit={exitButtonHandler}
              saveDraftAndExit={saveDraftAndExit}
            //  closeAfterSaving={closeAfterSaving}
            />
          </div>

          <div className="col text-end pt-24 padding-repair">
            <Button
              id="duprepair-btn1"
              onClick={handleContinue}
              //  disabled={BlockMsg === false ? true : isDisabled || disableContinueforEnhancedEligiblityCheck ? true : false}
              className="primary-btn"
            >
              {t("continuen_button")}
            </Button>
          </div>
        </div>
      </div>
    </Container>
  </>
  );
};
export default DMCQuestions;